import { useEffect } from 'react'

import { PENDO_READY_EVENT } from '../constants'

const initializePendo = (userId: string) => {
  if (typeof window === 'undefined' || !window.pendo) {
    return false
  }

  try {
    console.info('[Pendo] Initializing SDK with userId:', userId)
    window.pendo.initialize({
      visitor: {
        id: userId
      },
      account: {
        id: userId
      }
    })
  } catch (error) {
    console.warn('[Pendo] Failed to initialize:', error)
  }

  return true
}

const usePendo = (userId?: string | null) => {
  useEffect(() => {
    if (!userId) return

    if (initializePendo(userId)) return

    const handlePendoReady = () => {
      initializePendo(userId)
    }

    window.addEventListener(PENDO_READY_EVENT, handlePendoReady)

    return () => {
      window.removeEventListener(PENDO_READY_EVENT, handlePendoReady)
    }
  }, [userId])
}

export default usePendo
